import { IDecisionForm } from '../interfaces/IDecisionForm';

interface IMarkedField {
  appendShowMarkCondition?: (values: IDecisionForm) => boolean;
}

export const isFieldsRequiredForDecisionCompleted = (fieldName: string | undefined, values: IDecisionForm): boolean => {
  const idRegex = /\[\d+]/gi;
  const fieldNameTemplate = fieldName?.replaceAll(idRegex, '[{id}]');

  if (!fieldNameTemplate || !fieldsRequiredForDecisionCompleted[fieldNameTemplate]) {
    return false;
  }

  const markedField = fieldsRequiredForDecisionCompleted[fieldNameTemplate];

  return !markedField.appendShowMarkCondition || markedField.appendShowMarkCondition(values);
};

const fieldsRequiredForDecisionCompleted: Record<string, IMarkedField> = {
  'reasons[{id}].type': {
    appendShowMarkCondition: values => !values.reasons || values.reasons.length === 0 || !values.reasons?.[0]?.type,
  },
  objects: {
    appendShowMarkCondition: values => !values.objects || values.objects.length === 0,
  },
  organization: {},
  inspectors: {
    appendShowMarkCondition: values => !values.inspectors || values.inspectors.length === 0,
  },
  'organization.act': {
    appendShowMarkCondition: values => !!values.isNeedToAddAct?.value,
  },
  'organization.act.isViolatedMandatoryRequirements': {},
};
